module.exports = __webpack_public_path__ + "assets/img/teacher (40).eb8f6bec.png";